import React, { useState } from 'react';

import { Copy } from './copyDataStyles';
import { ClickText, ColoredTick, GenericSpan } from 'commonStyles';
import { ASSET_PATH } from 'assetsPath';
import { saveServerLogs } from 'UtilityComponents/Util';
import { INTEGRATION_AWARNESS_CONSTANTS } from 'AppConstants';

const CopyData = ({ colorTheme = {}, styles = {}, wrapper, copyStyles, data }) => {
	const copyColor = styles.copyColor || colorTheme.copyColor || '#FF664B';
	const copiedColor = styles.copiedColor || colorTheme.copiedColor || '#007E7D';

	const [copied, setCopied] = useState(false);

	const copyClip = () => {
		try {
			let r = document.createRange();
			r.selectNode(wrapper.current);
			window.getSelection().removeAllRanges();
			window.getSelection().addRange(r);
			document.execCommand('copy');
			window.getSelection().removeAllRanges();
			setCopied(true);
			setTimeout(() => {
				setCopied(false);
			}, 3000);
		} catch (e) {
			saveServerLogs(e.stack, 'error', 'selection copy error' + JSON.stringify(data));
			try {
				const cb = navigator.clipboard;
				cb.writeText(wrapper.current.innerText).then(() => alert('Text copied'));
			} catch (err) {
				saveServerLogs(err.stack, 'error', 'navigator clipboard copy error' + JSON.stringify(data));
			}
		}
	};

	return (
		<Copy
			{...copyStyles}
			as='a' f_weight='900' line_height='20px'
			top_P='10'
			bottom_P='10'
			left_P='10'
			right_P='10'
			onClick={copyClip}>
			{copied ? <ColoredTick valign='middle' /> : <GenericSpan valign='middle' width='16' as='img' src={ASSET_PATH.IMAGES + '/travelIntegration/copy.png'} />}
			<ClickText f_size='14' f_weight='700' left_M='5' color={copied ? copiedColor : copyColor}>{copied ? INTEGRATION_AWARNESS_CONSTANTS.COPIED : INTEGRATION_AWARNESS_CONSTANTS.COPY}</ClickText>
		</Copy>

	);
};

export default CopyData;
